require('./car-valuation.scss');

// Always include below because it's non deferred and ALWAYS RENDERED!
require('src/creative/core-page/core-page.scss'); // core page scss is needed because its core page :D
require('src/creative/core-page/other-model-years/other-model-years');
require('src/creative/nav/nav');
require('src/creative/core-page/submodel-selector/submodel-selector');
require('src/interlock/ui/subnav/subnav');
require('src/interlock/core-page/module-anchor/module-anchor');
require('src/interlock/product/global-footer/global-footer');
require('src/creative/ads/adhesion-units/adhesion-units');
require('src/interlock/no-ui/defer/feed-loader');
require('src/interlock/ui/base-carousel/base-carousel');
require('src/interlock/ui/owl-carousel/owl-carousel');
require('src/interlock/no-ui/engagement-handler/url-push-state-engagement-handler/url-push-state-engagement-handler');
require('src/interlock/core-page/dynamic-header/dynamic-header');
require('src/interlock/product/internal-links/internal-links');

require('src/creative/ads/ads');

var trackingMap = require('src/interlock/no-ui/tracking/maps/core-page'),
    trackingHandler = require('src/interlock/no-ui/tracking/handler');

trackingHandler.useMap(trackingMap);



//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/used/car-valuation/car-valuation.js
// module id = 162
// module chunks = 0 1 14